import * as types from 'store/modules/hress5u/mutation-types'
import hress5u from 'api/hress5u'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hress5uLabels from 'assets/labels/hress5u'
import { hress5uColumns } from 'assets/columns/hress5u'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hress5uLabels,
    columns: hress5uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        table: {
          total: 0,
          rows: []
        }
      }
    },
    popup1DetailTab2: {
      tab1: {}
    },
    popup2DetailTab2: {
      tab1: {},
      tab2: {
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        table: {
          total: 0,
          rows: []
        }
      },
      tab4: {
        table: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRESS5U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRESS5U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRESS5U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRESS5U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRESS5U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRESS5U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRESS5U_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRESS5U_DETAIL_TAB2_POPUP1] (state) {
      return state.popup1DetailTab2
    },
    [types.GET_HRESS5U_DETAIL_TAB2_POPUP2] (state) {
      return state.popup2DetailTab2
    }
  },
  mutations: {
    [types.SET_HRESS5U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRESS5U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRESS5U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
        state.columns[keyLang].detailTab2Popup2Tab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2Popup2Tab2, labels[keyLang])
        state.columns[keyLang].detailTab2Popup2Tab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2Popup2Tab3, labels[keyLang])
        state.columns[keyLang].detailTab2Popup2Tab4 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2Popup2Tab4, labels[keyLang])
      }
    },
    [types.SET_HRESS5U_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRESS5U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRESS5U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRESS5U_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRESS5U_DETAIL_TAB2_POPUP1] (state, popup1DetailTab2) {
      state.popup1DetailTab2 = popup1DetailTab2
    },
    [types.SET_HRESS5U_DETAIL_TAB2_POPUP2] (state, popup2DetailTab2) {
      state.popup2DetailTab2 = popup2DetailTab2
    }
  },
  actions: {
    [types.TOGGLE_HRESS5U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRESS5U_INDEX_DISP, indexDisp)
      commit(types.SET_HRESS5U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRESS5U_COLUMNS_LABELS] ({ commit }) {
      hress5u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_COLUMNS, data.labels)
          commit(types.SET_HRESS5U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS5U_INDEX] ({ commit }, searchParams) {
      hress5u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS5U_DETAIL] ({ commit }, searchParams) {
      hress5u.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS5U_DETAIL_TAB2_POPUP1] ({ commit }, searchParams) {
      hress5u.getPopup1DetailTab2(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_DETAIL_TAB2_POPUP1, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS5U_DETAIL_TAB2_POPUP2] ({ commit }, searchParams) {
      hress5u.getPopup2DetailTab2(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_DETAIL_TAB2_POPUP2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS5U_DROPDOWNS] ({ commit }) {
      hress5u.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS5U_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRESS5U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hress5u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRESS5U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hress5u/index.js